import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BlitzAPI from '../../api/BlitzAPI';

function StatItem(props) {
  const { caption, data, subdata, title } = props;

  const formattedData = data && data < 1 ? `${(data * 100).toPrecision(3)}%` : data;
  const formattedSubData = subdata && subdata < 1 ? `${(subdata * 100).toPrecision(3)}%` : subdata;


  return (
    <div className="dashboard-stat-item ">
      <h3>{title}</h3>
      <div className="dashboard-stat-content clearfix">
        <h4 className="dashboard-stat-number">{formattedData} {formattedSubData && `(${formattedSubData})`}</h4>

      </div>
      <p className="dashboard-stat-caption">{caption}</p>
    </div>
  );
}

StatItem.propTypes = {
  caption: PropTypes.string,
  data: PropTypes.number,
  subdata: PropTypes.number,
  title: PropTypes.string,
};

export default class AppTrackingDashboard extends Component {
  constructor(props) {
    super(props);
    this.getData = this.getData.bind(this);
    this.onMinGameChange = this.onMinGameChange.bind(this);
    this.state = {
      data: null,
      query: {},
      minGames: 1,
    };
  }

  componentDidMount() {
    this.getData();
  }

  onMinGameChange(e) {
    this.setState({ minGames: e.target.value });
    let { query } = this.state;
    if (!e.target.value) {
      delete query.at_least;
    } else {
      query = Object.assign({}, query, { at_least: e.target.value });
    }
    this.setState({ query }, this.getData);
  }

  getData() {
    const { query } = this.state;
    BlitzAPI.getStatsFilterable(query).then(resp => this.setState({ data: resp.data }));
  }

  render() {
    const { data, minGames } = this.state;

    return (
      <div className="dashboard">
        <h1>Filter Dashboard</h1>
        <h2 className="page-title dashboard-title">Overall Stats</h2>
        <label>Minimum number of games: </label><input type="number" onChange={this.onMinGameChange} value={minGames} />
        {data &&
          <div className="dashboard-stat clearfix">
            <StatItem
              title="Overall Ratio"
              data={data.overall_ratio}
              subdata={data.overall_count}
              caption="Average ratio of all users."
            />
            <StatItem
              title="Overall min game ratio"
              data={data.at_least_ratio}
              subdata={data.at_least_count}
              caption={`Average ratio of all users who have tracked at least ${minGames} time(s).`}
            />
            <StatItem
              title="Last Week min game Ratio"
              data={data.last_week_at_least_ratio}
              subdata={data.last_week_at_least_count}
              caption={`Last week ratio of users who have tracked at least ${minGames} time(s)`}
            />
            <StatItem
              title="Min game Lost users"
              data={data.lost_count}
              subdata={data.lost_count / data.at_least_count}
              caption={`users who stopped using the app (% of users) who've tracked at least ${minGames} games`}
            />
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/cms/tracking/AppTrackingFilter.js